import { useTranslation } from 'react-i18next'

import { Flex, Text, theme } from '@percent/lemonade'
import { Card } from '@percent/product-nomination-form/ui/Card/Card'
import { usePartnerConfig } from '@percent/product-nomination-form/hooks'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'
import { HostedFormStep } from '../../HostedForm.types'
import styles from './Introduction.module.scss'

export const Introduction = () => {
  const { t } = useTranslation()
  const { partnerConfig } = usePartnerConfig()
  const { handleNext } = useValidationStepData()

  return (
    <Card
      title={t('hostedValidation.introduction.title', {
        partner: partnerConfig?.configuration.partner.name,
      })}
      onNext={() => handleNext(HostedFormStep.NOMINATOR_DETAILS)}
      nextButtonLabel={t('hostedValidation.introduction.button')}
    >
      <Flex direction="column" gap={24} w="100%">
        {partnerConfig?.configuration.formCopy?.formIntroduction && (
          <Text
            size="medium"
            color={theme.colors.gray600}
            className={styles.formIntroduction}
          >
            {partnerConfig.configuration.formCopy.formIntroduction}
          </Text>
        )}
        {!partnerConfig?.configuration.formCopy?.formIntroduction && (
          <>
            <Text size="medium" color={theme.colors.gray600}>
              {t('hostedValidation.introduction.paragraph1')}
            </Text>
            <Text size="medium" color={theme.colors.gray600}>
              {t('hostedValidation.introduction.paragraph2')}
            </Text>
            <Text size="medium" color={theme.colors.gray600}>
              {t('hostedValidation.introduction.paragraph3')}
            </Text>
          </>
        )}
      </Flex>
    </Card>
  )
}
